<div class="position-relative">
  <div class="come overflow-hidden">
    <div class="position-relative">
      <app-banner></app-banner>
    </div>

    <!-- WAYS TO CONNECT -->
    <section class="ways-section wow fadeInDown">
      <div class="container ways-container">
        <div class="ways-heading gilroy">
          Ways to <span class="gilroy-b">connect</span> on
          <span class="gilroy-b">Mentoga</span>
        </div>
        <div class="ways-content">
          <div class="row ways-cards-container">
            @for (card of waysCards; track card) {
              <div class="col-lg-3 col-md-6 col-sm-12 ways-card-wrapper">
                <div class="ways-card-item">
                  <img class="ways-card-item-img" [src]="card?.imgUrl" alt="" />

                  <div class="ways-card-item-content">
                    <div class="gilroy-b ways-card-item-heading">
                      {{ card?.title }}
                    </div>
                    <div class="gilroy ways-card-item-sub-heading">
                      {{ card?.subTitle }}
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- FOR Creator/Fan -->
    <section class="for-creators-section wow fadeInDown">
      @if ((resize.windowSize$ | async)?.width > 768) {
        <div class="container for-creators-container">
          <img
            class="curve-img"
            alt="image"
            width="100%"
            height="100%"
            src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575645/Archive/curve_e4jsnl.svg"
          />

          <div class="for-creators-content">
            <div class="for-creators-text">
              <div class="gilroy-b creators">
                <div class="gilroy for">For</div>
                Creators
              </div>
              <div class="gilroy description">
                Monetize your influence with direct, one-on-one video calls,
                paid chats, and Mega Sessions. Engage with your audience on a
                deeper level while getting paid for your time
              </div>
            </div>
            <div class="for-creators-img">
              <img
                class="lazyImage"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                width="100%"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575646/Archive/forCreators_pkjhrk.png"
              />
            </div>
          </div>
          <div class="for-creators-content">
            <div class="for-creators-img">
              <img
                class="lazyImage btm-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                width="100%"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575647/Archive/forFans_i46mws.png"
              />
            </div>
            <div class="for-creators-text">
              <div class="gilroy-b creators">
                <div class="gilroy for">For</div>
                Fans
              </div>
              <div class="gilroy description">
                Go beyond likes and comments—have real one-on-one video calls
                with your favorite creators! Get exclusive insights, advice, or
                just a casual chat. Join Mentoga and connect like never before.
              </div>
            </div>
          </div>
        </div>
      } @else {
        <div class="container for-creators-mobile-container">
          <div class="for-creators-mobile-content">
            <div class="for-creators-mobile-text">
              <div class="gilroy creators">
                For <span class="gilroy-b">Creators</span>
              </div>
              <div class="gilroy description">
                Monetize your influence with direct, one-on-one video calls,
                paid chats, and Mega Sessions. Engage with your audience on a
                deeper level while getting paid for your time
              </div>
            </div>
            <div class="for-creators-mobile-img">
              <img
                class="lazyImage"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                width="100%"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575646/Archive/forCreatorsMobile_rin8ij.png"
              />
            </div>
          </div>
          <div class="for-creators-mobile-content">
            <div class="for-creators-mobile-text">
              <div class="gilroy creators">
                For <span class="gilroy-b">Fans</span>
              </div>
              <div class="gilroy description">
                Go beyond likes and comments—have real one-on-one video calls
                with your favorite creators! Get exclusive insights, advice, or
                just a casual chat. Join Mentoga and connect like never before.
              </div>
            </div>
            <div class="for-creators-mobile-img">
              <img
                class="lazyImage btm-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                width="100%"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575647/Archive/forFansMobile_st8to6.png"
              />
            </div>
          </div>
        </div>
      }
    </section>

    <!-- Popular creators-->
    @if ((resize.windowSize$ | async)?.width > 768) {
      <section class="popular-creators-section wow fadeInDown">
        <div class="container popular-creators-container">
          <div class="popular-creators-content">
            <div class="popular-creators-text">
              <div class="gilroy creators">
                Popular <span class="gilroy-b">Creators</span>
              </div>
              <div class="gilroy description">
                Explore Mentoga’s most popular creators.
              </div>
              <button class="gilroy" routerLink="/creators">
                See All Creators
              </button>
            </div>
            <div class="popular-creators-img">
              <img
                class="lazyImage popular-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/popular_bbilrm.png"
              />
            </div>
          </div>
        </div>
      </section>
    } @else {
      <section class="popular-creators-mobile-section wow fadeInDown">
        <div class="container popular-creators-mobile-container">
          <div class="popular-creators-mobile-content">
            <div class="popular-creators-mobile-text">
              <div class="gilroy creators">
                Popular <span class="gilroy-b">Creators</span>
              </div>
              <div class="gilroy description">
                Explore Mentoga’s most popular creators.
              </div>
              <button class="gilroy" routerLink="/creators">
                See All Creators
              </button>
            </div>
            <div class="popular-creators-mobile-img">
              <img
                class="lazyImage popular-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/popularMobile_ewgcss.png"
              />
            </div>
          </div>
        </div>
      </section>
    }

    <!-- Branding Video -->
    <section class="brand-video-section wow fadeInDown">
        <div class="container brand-video-container">
          <div class="brand-video-content reverse">
            <div class="brand-video-img">
              <ngx-lite-youtube
                thumbQuality="high"
                [allowFullScreen]="true"
                [hasControls]="true"
                videoId="UgYZoqz_zq4"
              ></ngx-lite-youtube>
              @if ((resize.windowSize$ | async)?.width > 768) {
              <img
                class="lazyImage dark-star"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                lazyLoad="assets/images/starShape.png"
              />
              <img
                class="lazyImage green-star"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575667/Archive/starGreen_zzndeh.svg"
              />
              }
            </div>
            <div class="brand-video-text">
              <div class="gilroy creators">
                What <span class="gilroy-b">Creators</span> Say <br />
                About <span class="gilroy-b">Mentoga</span>
                <img
                  class="lazyImage tooltip-video"
                  defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                  [useSrcset]="false"
                  alt="image"
                  lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749497/Archive%20%281%29/comments_fai2kj.svg"
                />
              </div>
            </div>
          </div>
          <div class="brand-video-content">
            <div class="brand-video-text">
              <div class="gilroy creators">
                <span class="gilroy-m creators-lg">Creators. Fans.</span><br />
                Nothing in Between.
              </div>
              <button class="gilroy" routerLink="/signup">
                <img
                  class="lazyImage green-star"
                  defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                  [useSrcset]="false"
                  alt="image"
                  lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749496/Archive%20%281%29/greeenStar_yfpfbi.svg"
                />
                Let's Connect
              </button>
            </div>
            <div class="brand-video-img">
              <img
                class="lazyImage btm-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575645/Archive/comments_oafuuc.png"
              />
            </div>
          </div>
        </div>
      <!-- } -->
       <!-- @else {
        <div class="container brand-video-mobile-container">
          <div class="brand-video-mobile-content">
            <div class="brand-video-mobile-text">
              <div class="gilroy creators">
                <img
                  class="lazyImage tooltip-video"
                  defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                  [useSrcset]="false"
                  alt="image"
                  lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749497/Archive%20%281%29/comments_fai2kj.svg"
                />
                What <span class="gilroy-b">Creators</span> Say <br />
                About <span class="gilroy-b">Mentoga</span>
              </div>
            </div>
            <div class="brand-video-mobile-img">
              <ngx-lite-youtube
                thumbQuality="high"
                [allowFullScreen]="true"
                [hasControls]="true"
                videoId="UgYZoqz_zq4"
              ></ngx-lite-youtube>
            </div>
          </div>
          <div class="brand-video-mobile-content">
            <div class="brand-video-mobile-text">
              <div class="gilroy creators">
                <span class="gilroy-m creators-lg">Creators. Fans.</span><br />
                Nothing in Between.
              </div>
              <button class="gilroy" routerLink="/signup">
                <img
                  class="lazyImage green-star"
                  defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                  [useSrcset]="false"
                  alt="image"
                  lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749496/Archive%20%281%29/greeenStar_yfpfbi.svg"
                />
                Let's Connect
              </button>
            </div>
            <div class="brand-video-mobile-img">
              <img
                class="lazyImage btm-img"
                defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                [useSrcset]="false"
                alt="image"
                height="100%"
                lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575645/Archive/comments_oafuuc.png"
              />
            </div>
          </div>
        </div>
      } -->
    </section>

    <!-- MAP SECTION -->
    <section class="map-section wow fadeInDown">
      <div class="container map-container">
        <div class="map-heading gilroy">
          The <span class="gilroy-b">Global Network</span> of Creators
        </div>
        <div class="map-subheading gilroy">
          Global community of <span class="gilroy-b">creators</span>, connecting
          with <span class="gilroy-b">fans</span> and
          <span class="gilroy-b">audiences worldwide</span>
        </div>
        <div class="map-content">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-10 mb-3 mx-auto">
                <div class="mapBox">
                  <img
                    class="lazyImage"
                    defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
                    [useSrcset]="false"
                    alt="image"
                    width="100%"
                    height="100%"
                    lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575650/Archive/mapPin_bzvnxx.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- PROS AND CONS SECTION -->
    <section class="pro-cons-section wow fadeInDown">
      <div class="pro-cons-section-container">
        <div class="pro-cons-section-content">
          <div class="subSection pro">
            <div class="heading gilroy-sb">
              With Mentoga
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575650/Archive/proIn_mhcjb8.svg" alt="" />
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/pro_wpbo21.svg" alt="" />
              <div class="gilroy">Additional Revenue</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/pro_wpbo21.svg" alt="" />
              <div class="gilroy">Skill Monetization</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/pro_wpbo21.svg" alt="" />
              <div class="gilroy">Thriving Creator Community</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575649/Archive/pro_wpbo21.svg" alt="" />
              <div class="gilroy">Maximize Fan Value</div>
            </div>
          </div>
          <div class="subSection nopro">
            <div class="heading gilroy-sb">
              Without Mentoga
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749496/Archive%20%281%29/proOut_yn1iw7.svg" alt="" />
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575648/Archive/nopro_vevzdy.svg" alt="" />
              <div class="gilroy">Missed Revenue Opportunities</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575648/Archive/nopro_vevzdy.svg" alt="" />
              <div class="gilroy">Underutilized Expertise</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575648/Archive/nopro_vevzdy.svg" alt="" />
              <div class="gilroy">Disconnected Audience</div>
            </div>
            <div class="item">
              <img src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575648/Archive/nopro_vevzdy.svg" alt="" />
              <div class="gilroy">Limited Fan Engagement</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- JOIN SECTION -->
    <section class="footer-section wow fadeInDown" style="margin: 32px 0px">
      <div class="container footer-container">
        <img
          class="lazyImage footer-bg"
          defaultImage="https://res.cloudinary.com/dmdawjgs8/image/upload/v1701082076/comejoinus/new/brokenimg_1_r0bg15.webp"
          [useSrcset]="false"
          alt="image"
          width="100%"
          height="100%"
          lazyLoad="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575646/Archive/footerBg_djrofo.svg"
        />
        <div class="footer-heading gilroy-m">
          <span class="gilroy-b">Join Mentoga’s</span> growing network of
          creators and connect with millions, turning your passion into profit
          while building your brand and business.
        </div>
        <div class="footer-content">
          <div>
            <button class="gilroy-b wow fadeInDown" routerLink="/signup">
              Join Now
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
